import { LinearProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CoinInfo from "../Components/CoinInfo";
import { SingleCoin } from "../config/api";
import { CryptoState } from "../CryptoContext";
import getColorsHook from "../getColorsHook";
import { formatNumber, getCurrencySymbol } from "../utils/formatters";
import styles from "./style.module.css";

const CoinPage = () => {
  const [colors] = getColorsHook();

  const { id } = useParams();
  const [coin, setCoin] = useState();

  const { currency } = CryptoState();

  const fetchCoin = async () => {
    // setLoading(true);
    const { data } = await axios.get(SingleCoin(id));
    setCoin(data);
    // setLoading(false);
  };

  useEffect(() => {
    fetchCoin();
  }, []);

  if (!coin) return <LinearProgress style={{ background: "gold" }} />;

  return (
    <div
      className={styles.container}
      style={{
        color: colors.text2,
        background: colors.bgContrast,
        paddingTop: 75,
      }}
    >
      <div className={styles.sidebar}>
        <img
          src={coin?.image?.large}
          alt="logo"
          height={200}
          style={{ marginBottom: 30 }}
        />
        <div className={styles.ticker}>{coin?.symbol?.toUpperCase()}</div>
        <div className={styles.h1}>{coin?.name}</div>
        <div
          className={styles.desc}
          style={{ padding: 20 }}
          dangerouslySetInnerHTML={{
            __html: coin?.description.en.split(". ")[0],
          }}
        />

        <div className={styles.p2}>
          <span className={styles.h2}>Rank : </span>
          {coin?.market_cap_rank}
        </div>

        <div className={styles.p2}>
          <span className={styles.h2}>Price : </span>
          {getCurrencySymbol(currency)}
          {formatNumber(
            coin?.market_data.current_price[currency.toLowerCase()]
          )}
        </div>
      </div>
      <CoinInfo coin={coin} />
    </div>
  );
};

export default CoinPage;
